export default __webpack_public_path__ + "static/media/wallpaper_login.ab0beab7.jpg";